"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTasksMaxLoad = exports.calculateLoadAggregations = void 0;
var types_1 = require("@bringg/types");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var groupBy_1 = __importDefault(require("lodash/groupBy"));
var isNil_1 = __importDefault(require("lodash/isNil"));
var hierarchy_actions_1 = require("../task_inventories/hierarchy_actions");
var with_custom_status_1 = require("../task_inventories/with_custom_status");
var aggregation_types_1 = require("./aggregation_types");
var task_inventories_load_aggregator_1 = require("./task_inventories_load_aggregator");
function sortTasks(tasks) {
    return __spreadArray([], tasks, true).sort(function (a, b) { return a.priority - b.priority; });
}
function getTaskInventoriesFromTasks(tasks) {
    return (0, flatMap_1.default)(tasks, function (task) {
        var taskStatus = task.status;
        var clonedTaskInventories = (0, cloneDeep_1.default)(task.task_inventories || []);
        var nestedTaskInventories = (0, hierarchy_actions_1.buildTaskInventoriesHierarchy)(clonedTaskInventories);
        var taskInventoriesByWaypoint = (0, groupBy_1.default)(nestedTaskInventories, 'way_point_id');
        return (0, flatMap_1.default)(task.way_points, function (wayPoint) {
            var taskInventories = taskInventoriesByWaypoint[wayPoint.id] || [];
            return taskInventories
                .map(function (taskInventory) {
                var status;
                if (taskStatus === types_1.TaskStatus.Done || (taskInventory.pending && !(0, isNil_1.default)(wayPoint.checkout_time))) {
                    status = with_custom_status_1.TaskInventoryStatus.DONE;
                }
                else if (taskStatus === types_1.TaskStatus.Cancelled) {
                    status = with_custom_status_1.TaskInventoryStatus.CANCELLED;
                }
                else {
                    status = with_custom_status_1.TaskInventoryStatus.INCOMPLETED;
                }
                return __assign(__assign({ customerId: wayPoint.customer_id }, taskInventory), { status: status });
            })
                .sort(function (a, b) { return +a.pending - +b.pending; });
        });
    });
}
function getTaskInventoriesOrderedByCustomers(tasks) {
    var taskInventories = getTaskInventoriesFromTasks(tasks);
    var customersPosition = {};
    var taskInventoryToCustomerPosition = {};
    return taskInventories
        .map(function (taskInventory, index) {
        if (taskInventory.pending) {
            var newIndex = customersPosition[taskInventory.customerId];
            if ((0, isNil_1.default)(newIndex)) {
                newIndex = index;
            }
            customersPosition[taskInventory.customerId] = newIndex;
            taskInventoryToCustomerPosition[taskInventory.id] = newIndex;
        }
        else {
            taskInventoryToCustomerPosition[taskInventory.id] = index;
        }
        return taskInventory;
    })
        .sort(function (x, y) { return taskInventoryToCustomerPosition[x.id] - taskInventoryToCustomerPosition[y.id]; });
}
function calculateLoadAggregations(aggregationTypes, _a) {
    var items = _a.items, field = _a.field, ignoreQuantity = _a.ignoreQuantity, isClusterMode = _a.isClusterMode, uniqueInventoryFields = _a.uniqueInventoryFields;
    var sortedTasks = sortTasks(items);
    var taskInventories = isClusterMode
        ? getTaskInventoriesOrderedByCustomers(sortedTasks)
        : getTaskInventoriesFromTasks(sortedTasks);
    return (0, task_inventories_load_aggregator_1.calculateAggregations)(aggregationTypes, {
        items: taskInventories,
        field: field,
        ignoreQuantity: ignoreQuantity,
        uniqueInventoryFields: uniqueInventoryFields
    });
}
exports.calculateLoadAggregations = calculateLoadAggregations;
function calculateTasksMaxLoad(_a) {
    var items = _a.items, field = _a.field, ignoreQuantity = _a.ignoreQuantity, isClusterMode = _a.isClusterMode, uniqueInventoryFields = _a.uniqueInventoryFields;
    var aggregationType = aggregation_types_1.AggregationTypes.MAX_LOAD;
    return calculateLoadAggregations([aggregationType], {
        items: items,
        field: field,
        ignoreQuantity: ignoreQuantity,
        isClusterMode: isClusterMode,
        uniqueInventoryFields: uniqueInventoryFields
    })[aggregationType];
}
exports.calculateTasksMaxLoad = calculateTasksMaxLoad;
//# sourceMappingURL=tasks_load_aggregators.js.map